import ReactDOM from 'react-dom';
import usePortal from './usePortal';
const Portal = (props) => {
    const target = usePortal('portal');
    return ReactDOM.createPortal(props.children, target);
};
export default Portal;
//# sourceMappingURL=Portal.js.map